/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiHttpBody } from '../../models/api-http-body';

export interface AdminServiceGetGachaImageData$Params {
  environment: 'UNDEFINED' | 'STAGING' | 'PRODUCTION';
  gachaId: string;
}

export function adminServiceGetGachaImageData(http: HttpClient, rootUrl: string, params: AdminServiceGetGachaImageData$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiHttpBody>> {
  const rb = new RequestBuilder(rootUrl, adminServiceGetGachaImageData.PATH, 'get');
  if (params) {
    rb.path('environment', params.environment, {});
    rb.path('gachaId', params.gachaId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiHttpBody>;
    })
  );
}

adminServiceGetGachaImageData.PATH = '/api/v3/gateway/admin/{environment}/gacha/{gachaId}/image/raw';
